export default __webpack_public_path__ + "fonts/ee8a457f6a30278bfbf3bf6ada14ec2b.woff2";